import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Avatar,
  Container,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { hraimg } from "../../assets";

const LuxuryHero: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "95vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0f63a5",
        px: 2,
        py: { xs: 4, lg: 'auto' }
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: 1200,
            width: { xs: 'aut', lg: "100%" },
            background:
              "linear-gradient(180deg, #F8FAFC 0%, #EEF2F7 100%)",
            borderRadius: "32px",
            px: { xs: 2, md: 4 },
            py: { xs: 4, md: 6 },
            mx: "auto",
            height: "auto",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            {/* LEFT SECTION */}
            <Grid item xs={12} md={6}>
              <Typography fontWeight={700} variant="h5" sx={{ textAlign: "start" }}>
                ABOUT US
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 0, mt: 2 }}>
                {["Clarity", "Confidence", "Conversion"].map((item, index) => (
                  <React.Fragment key={item}>
                    {index !== 0 && (
                      <Typography
                        component="span"
                        sx={{
                          fontSize: 24,      // ✅ Bigger dot
                          fontWeight: 700,
                          color: "#0f63a5",
                          mx: 1,
                        }}
                      >
                        •
                      </Typography>
                    )}

                    <Typography
                      component="span"
                      fontSize={14}
                      fontWeight={600}
                      color="#0f63a5"
                    >
                      {item}
                    </Typography>
                  </React.Fragment>
                ))}
              </Box>

              <Typography
              variant="body2"
                sx={{
                  mt: 2,
                  // fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#555",
                  textAlign: "start",
                }}
              >
                We work with real estate developers and teams handling high-value inventory, bringing structure, strategy, and execution into their sales ecosystem.
              </Typography>
              <Typography
              variant="body1"
                sx={{
                  mt: 1,
                  fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#000",
                  textAlign: "start",
                }}
              >
                Our focus is simple:
              </Typography>

              <Typography
              variant="body2"
                sx={{
                  mt: 1,
                  // fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#555",
                  textAlign: "start",
                }}
              >
                 help teams communicate better, position stronger, and convert high-ticket opportunities with confidence.
              </Typography>
              <Typography
              variant="body2"
                sx={{
                  mt: 2,
                  // fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#555",
                  textAlign: "start",
                }}
              >
                Our approach is rooted in buyer psychology, real market conversations, and on-ground execution, not theory, not motivation.
              </Typography>
              <Typography
              variant="body2"
                sx={{
                  mt: 2,
                  // fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#555",
                  textAlign: "start",
                }}
              >
                Every engagement is built around how sales actually happen in real life.
              </Typography>

              <Typography
                variant="h5"
                sx={{ fontWeight: 700, mt: 3, textAlign: "start" }}
              >
                WHAT WE DO
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#0f63a5",
                  mt: 1,
                  textAlign: "start",
                }}
              >
                We partner with real estate developers to manage and strengthen the sales of premium and luxury inventory.
              </Typography>

              <Typography variant="body1" sx={{ mt: 1, textAlign: "start" }}>
                This includes:
              </Typography>

              {[
                "Sales Strategy & Positioning : Aligning project narrative with the right target audience",
                "Sales Team Enablement : Training teams to handle high-ticket buyers with clarity and confidence",
                "On-Ground Sales Execution : Supporting site visits, conversations, and deal movement",
                "High-Ticket Client Handling : Structuring communication for premium buyers",
                "Sales Process & SOP Development : Building systems that bring consistency and control ",
                "Workshops & Real-Time Training : Practical, scenario-based learning for live sales environments",

              ].map((item) => (
                <Typography
                
                  key={item}
                  variant="body2"
                  mt={1}
                  sx={{
                    // fontSize: { xs: "13px", md: "14px", lg: "17px" },
                    fontWeight: 600,
                    color: "#555",
                    textAlign: "start",
                  }}
                >
                  • {item}
                </Typography>
              ))}

              {/* <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontSize: { xs: "13px", md: "14px", lg: "17px" },
                  color: "#555",
                  textAlign: "start",
                }}
              >
                Every engagement is practical, market-tested, and designed for real time sales scenarios and conversations.
              </Typography> */}

              <Box sx={{ width: "100%", textAlign: "left" }}>
                <Button
                  component="a"
                  href="https://wa.me/+919885420885?text=Hi%20there!%20I%20am%20interested%20in%20your%20luxury%20slaes%20services."
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    mt: 4,
                    background:
                      "linear-gradient(135deg, #1c5ea9, #33a6ea, #0d4677)",
                    color: "#fff",
                    borderRadius: "10px",
                    px: 4,
                    py: 1.5,
                    textTransform: "none",
                    display: "inline-flex",
                    textDecoration: "none",
                  }}
                >
                  Let’s Connect
                </Button>
              </Box>


            </Grid>

            {/* RIGHT SECTION */}
            <Grid item xs={12} md={6}>
              <Box sx={{ position: "relative", height: { xs: 410, lg: 520 } }}>
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(255,255,255,0.35)",
                    backdropFilter: "blur(20px)",
                    borderRadius: "24px",
                  }}
                />

                <Box
                  component="img"
                  src="https://dprstorage.b-cdn.net/RW/rwimage1.jpg"
                  alt="Coach"
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 380,
                    borderRadius: "15px",
                    zIndex: 2,
                  }}
                />

                {/* GRADIENT CARD */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: { xs: 0, lg: 0 },
                    right: { xs: 0, lg: 0},
                    width: { xs: "95%",md:"72%", lg: 332 },
                    p: { xs: 1, lg: 3 },
                    borderRadius: "15px",
                    height:"50px",
                    color: "#fff",
                    background:
                      "linear-gradient(135deg, #1c5ea9, #33a6ea, #0d4677)",
                    zIndex: 3,
                    overflow: "hidden", // important
                  }}
                >
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Box>
                      <Typography
                        fontWeight={600}
                        sx={{ color: "white" }}
                      >
                        Rajiv WILLIAMS
                      </Typography>
                    </Box>

                    <Box>
                      <VerifiedUserIcon sx={{ color: "white" }} />
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography
                      fontWeight={600}
                      variant="body2"
                      sx={{
                        color: "white",
                        fontSize: { xs: "13px", md: "14px", lg: "16px" },
                        textAlign: "start",
                        zIndex: 2,
                        position: "relative",
                        mb: 1
                      }}
                    >
                      Luxury Sales Coach & Consultant
                    </Typography>
                  </Box>

                  {/* 🔥 HRA IMAGE – BOTTOM RIGHT */}
                  {/* <Box
                    component="img"
                    src={hraimg} // ← replace with your actual path
                    alt="HRA"
                    sx={{
                      position: "absolute",
                      bottom: 4,
                      right: 12,
                      width: {xs:"58%",lg:159},
                      height: { xs: 29, lg: 30 },
                      opacity: 0.9,
                    }}
                  /> */}

                  
                </Box>
              </Box>



            </Grid>

          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default LuxuryHero;
